import { updateEventUserInfo, getEventUserInfo } from "@/api/user";
import { getEventSchoolList, getEventId } from "@/api/event";
import { getStoreUserObj, setStoreUserObj } from "@/utils/token";
import { handleSSOLogin } from "@/utils/sso-login";
import { clearToken, getStoreToken } from "@/utils/token";
export default {
  name: "UserInfo",
  components: {},
  mixins: [],
  props: {},
  data() {
    //  // 姓名校验正则：允许汉字（含繁简体）、字母、连字符（-）、半角空格、中文顿号（、）撇号（'）
    // const nameRegex = /^[\u4e00-\u9fa5\u3400-\u4dbf\uf900-\ufaffa-zA-Z\s\-、']+$/;
    // // 职务校验正则：允许汉字、字母、数字、空格、点号（.）、斜杠（/）、连字符（-）、括号（()）
    // const positionRegex = /^[\u4e00-\u9fa5a-zA-Z0-9\s./\-()]+$/;

    return {
      visible: false,
      schoolList: [],
      formData: {
        userPhone: "",
        userName: "",
        schoolId: "",
        userPosition: ""
      },
      eventId: "",
      userInfo: {},
      rules: {
        userPhone: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        }, {
          min: 11,
          max: 11,
          message: "请输入正确的手机号",
          trigger: "blur"
        }],
        userName: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }, {
          pattern: /^[\u4e00-\u9fa5\u3400-\u4dbf\uf900-\ufaffa-zA-Z0-9\s\-、']+$/,
          message: "姓名只能包含汉字、字母、数字、连字符(-)、顿号或撇号",
          trigger: "blur"
        }],
        schoolId: [{
          required: true,
          message: "请选择所属院校",
          trigger: "change"
        } // 新增必填规则
        ],
        userPosition: [{
          required: true,
          message: "请输入职务",
          trigger: "blur"
        },
        // 新增必填规则
        {
          pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s./\-()]+$/,
          message: "职务只能包含汉字、字母、数字、点号、斜杠、连字符(-)或括号",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.getEventSchoolList();
      }
    }
  },
  mounted() {
    if (!getStoreToken()) {
      handleSSOLogin();
    } else {
      this.getEventId();
    }
  },
  methods: {
    show(params) {
      if (!params) {
        params = {};
      }
      this.formData = {
        ...this.formData,
        ...params
      };
      this.visible = true;
    },
    async getEventId() {
      let res = await getEventId(this.$route.query.cmsId);
      if (res.code == 200) {
        this.eventId = res.data.id;
        let res1 = await getEventSchoolList(this.eventId);
        if (res1.code === 200) {
          this.schoolList = res1.data;
        }
        this.getEventUserInfo();
      } else if (res.code == 401) {
        clearToken();
        handleSSOLogin();
      }
    },
    async getEventUserInfo() {
      let res = await getEventUserInfo(this.eventId);
      if (res.code == 200) {
        this.userInfo = res.data;
        this.formData = {
          ...this.userInfo,
          schoolId: this.userInfo.schoolId || "",
          eventId: this.eventId
        };
      }
    },
    async submit() {
      let valid = await this.$refs.formRef.validate();
      if (valid) {
        let res = await updateEventUserInfo({
          id: this.formData.id,
          eventId: this.formData.eventId,
          realName: this.formData.userName,
          userPosition: this.formData.userPosition,
          schoolId: this.formData.schoolId
        });
        if (res.code === 200) {
          this.$message.success("操作成功");
          this.visible = false;
          this.getEventUserInfo();
          this.$emit("updateUserInfo", {
            id: this.formData.id,
            eventId: this.formData.eventId,
            realName: this.formData.userName,
            userPosition: this.formData.userPosition,
            schoolId: this.formData.schoolId
          });
          if (this.formData.userName) {
            setStoreUserObj({
              ...getStoreUserObj(),
              realName: this.formData.userName
            });
          }
        }
      }
    },
    async getEventSchoolList() {
      let res = await getEventSchoolList(this.eventId);
      if (res.code === 200) {
        this.schoolList = res.data;
      }
    }
  }
};